export const partners = [
  { id: "1", name: "Global Tech Corp", logoUrl: "" },
  { id: "2", name: "Cloud Solutions Inc", logoUrl: "" },
  { id: "3", name: "Future Innovators", logoUrl: "" },
  { id: "4", name: "AI Pioneers", logoUrl: "" },
];

export const coreValues = [
  {
    id: "1",
    title: "Tử tế",
    description:
      "Kinh doanh bằng sự chân thành, đối xử với khách hàng và đồng nghiệp bằng cái tâm.",
    icon: "favorite",
  },
  {
    id: "2",
    title: "Trung thực",
    description:
      "Minh bạch trong mọi quy trình, cam kết nói thật và làm thật trong mọi dự án.",
    icon: "verified_user",
  },
  {
    id: "3",
    title: "Chia sẻ",
    description:
      "Cùng phát triển, sẵn lòng hỗ trợ cộng đồng và đối tác để kiến tạo giá trị chung.",
    icon: "groups",
  },
  {
    id: "4",
    title: "Nhanh & Tốt",
    description:
      "Thích ứng linh hoạt, tối ưu quy trình để mang lại hiệu quả trong thời gian ngắn nhất.",
    icon: "bolt",
  },
];

export const services = [
  {
    id: "1",
    slug: "ha-tang-so",
    title: "Hạ tầng số",
    description:
      "Nền tảng Cloud Computing & Data Center chuẩn quốc tế, bảo vệ doanh nghiệp với các giải pháp an ninh mạng tối tân nhất.",
    icon: "cloud_done",
    features: ["Hybrid Cloud", "Security Audit"],
    color: "brand-primary",
  },
  {
    id: "2",
    slug: "giai-phap-phan-mem",
    title: "Giải pháp phần mềm",
    description:
      "May đo hệ thống ERP, CRM và Mobile App tối ưu cho quy trình đặc thù của từng doanh nghiệp.",
    icon: "developer_mode",
    features: ["Custom ERP", "UI/UX Design"],
    color: "brand-accent",
  },
  {
    id: "3",
    slug: "edtech",
    title: "EdTech",
    description:
      "Mang tri thức đến mọi nơi bằng công nghệ. Nền tảng LMS và AI tương tác giúp cá nhân hóa lộ trình học tập.",
    icon: "school",
    features: ["LMS Platforms", "AI Tutoring"],
    color: "emerald-500",
  },
  {
    id: "4",
    slug: "media-studio",
    title: "Media & DIY",
    description:
      "Sản xuất nội dung số và phát triển cộng đồng đam mê công nghệ thông qua các giải pháp sáng tạo tự làm.",
    icon: "movie_edit",
    features: ["Content Production", "Tech Workshops"],
    color: "indigo-600",
  },
];

export const stats = [
  { id: "kinh-nghiem", label: "Năm kinh nghiệm", value: "10+" },
  { id: "du-an", label: "Dự án hoàn tất", value: "500+" },
  { id: "chuyen-gia", label: "Chuyên gia IT", value: "100+" },
  { id: "doi-tac", label: "Đối tác toàn cầu", value: "50+" },
];

export const leadership = [
  {
    id: "1",
    name: "Ông Trần Đức Hiếu",
    title: "Giám Đốc Điều Hành",
    description:
      "Chuyên gia chiến lược với hơn 15 năm kinh nghiệm dẫn dắt các tập đoàn công nghệ lớn.",
    image: "/images/tranduchieu.jpeg",
  },
  {
    id: "2",
    name: "Ông Đậu Nguyên Thế",
    title: "Giám Đốc Kinh Doanh",
    description:
      "Tiên phong trong việc ứng dụng AI và Blockchain vào các giải pháp doanh nghiệp thực tiễn.",
    image: "/images/daunguyenthe.jpeg",
  },
  {
    id: "3",
    name: "Ông Chu Văn Tú",
    title: "Giám Đốc Công Nghệ",
    description:
      "Tối ưu hóa quy trình vận hành Agile, đảm bảo hiệu suất tối đa cho toàn bộ hệ sinh thái.",
    image: "/images/chuvantu.jpeg",
  },
  {
    id: "4",
    name: "Ông Lê Thanh Tùng",
    title: "Giám Đốc Kỹ Thuật",
    description:
      "Chuyên gia chiến lược với hơn 15 năm kinh nghiệm dẫn dắt các tập đoàn công nghệ lớn.",
    image: "/images/tung.jpeg",
  },
  {
    id: "6",
    name: "Bà Trịnh Thị Lan Anh",
    title: "Giám đốc Tài Chính",
    description:
      "Tối ưu hóa quy trình vận hành Agile, đảm bảo hiệu suất tối đa cho toàn bộ hệ sinh thái.",
    image: "/images/trinhthilananh.jpeg",
  },
];

export const testimonials = [
  {
    id: "1",
    content:
      "Hệ sinh thái của AHV thực sự thay đổi cách chúng tôi vận hành. Giải pháp Cloud và ERP may đo giúp tối ưu hóa 30% chi phí vận hành chỉ sau 6 tháng.",
    author: "Hoàng Nam",
    position: "CEO, TechCore Vietnam",
    avatar:
      "https://lh3.googleusercontent.com/aida-public/AB6AXuAo504Y7ZeFNcmp5n_qqpzMoU_6aOZOno-NuB9d88LSXpDS8CyIJTurSqKW8VrQ3hU7fwSHaVei06ZW2tV4EeE1_Ggrux2lLpKj-v01RT9AHDld_jce4KVSn9Xbpr-4ZwarqN48ACtBxjviofqBo9qkV9jH3pVm8x3y89q8O5fZ_GYIu92fAAGLCxfbJwGHLUwloUyCGWbPgEccvftCUoWvK6kMcyu8vqYbbykZPwdZ-35MS4SMly82cFF2LQ5ZSH-ZaxnlAdG0mTw",
  },
  {
    id: "2",
    content:
      "Đội ngũ kỹ thuật của AHV rất chuyên nghiệp và nhanh nhẹn. Họ không chỉ bán sản phẩm mà còn đồng hành như một đối tác chiến lược thực thụ.",
    author: "Minh Anh",
    position: "CTO, EduSmart",
    avatar:
      "https://lh3.googleusercontent.com/aida-public/AB6AXuAo504Y7ZeFNcmp5n_qqpzMoU_6aOZOno-NuB9d88LSXpDS8CyIJTurSqKW8VrQ3hU7fwSHaVei06ZW2tV4EeE1_Ggrux2lLpKj-v01RT9AHDld_jce4KVSn9Xbpr-4ZwarqN48ACtBxjviofqBo9qkV9jH3pVm8x3y89q8O5fZ_GYIu92fAAGLCxfbJwGHLUwloUyCGWbPgEccvftCUoWvK6kMcyu8vqYbbykZPwdZ-35MS4SMly82cFF2LQ5ZSH-ZaxnlAdG0mTw",
  },
  {
    id: "3",
    content:
      'Tôi đánh giá cao triết lý "Tử tế" của AHV. Sự minh bạch trong quy trình giúp chúng tôi hoàn toàn yên tâm khi triển khai các dự án quy mô lớn.',
    author: "Văn Đức",
    position: "Director, Global Logistics",
    avatar:
      "https://lh3.googleusercontent.com/aida-public/AB6AXuC515wQqupYd08O13v8cSNzrmj1JJdCt8Ujdb8v8krxfjp2BGDw05jMCxa8GTz556zvUi2Rnn9QUpv7MknUdSqQ3QZ1qG8k_stcVfvqw7xcfN5IympYYZjCoWLrz1s064_WZcATthsaB5v29Vw8v3ZJgV0o50xHCIv2NJhCXr0A6f8Q0kR7Tut0Lbvaq1B9_qHZIdI90vIFfqn6efjJCKYueM0QJlL2zZceAQsUeqMkfMKSwyy7iGLrpfzG4R3mmHCVZXr0B7GHavc",
  },
  {
    id: "4",
    content:
      "Đội ngũ kỹ thuật của AHV rất chuyên nghiệp và nhanh nhẹn. Họ không chỉ bán sản phẩm mà còn đồng hành như một đối tác chiến lược thực thụ.",
    author: "Minh Anh",
    position: "CTO, EduSmart",
    avatar:
      "https://lh3.googleusercontent.com/aida-public/AB6AXuAo504Y7ZeFNcmp5n_qqpzMoU_6aOZOno-NuB9d88LSXpDS8CyIJTurSqKW8VrQ3hU7fwSHaVei06ZW2tV4EeE1_Ggrux2lLpKj-v01RT9AHDld_jce4KVSn9Xbpr-4ZwarqN48ACtBxjviofqBo9qkV9jH3pVm8x3y89q8O5fZ_GYIu92fAAGLCxfbJwGHLUwloUyCGWbPgEccvftCUoWvK6kMcyu8vqYbbykZPwdZ-35MS4SMly82cFF2LQ5ZSH-ZaxnlAdG0mTw",
  },
  {
    id: "5",
    content:
      'Tôi đánh giá cao triết lý "Tử tế" của AHV. Sự minh bạch trong quy trình giúp chúng tôi hoàn toàn yên tâm khi triển khai các dự án quy mô lớn.',
    author: "Văn Đức",
    position: "Director, Global Logistics",
    avatar:
      "https://lh3.googleusercontent.com/aida-public/AB6AXuC515wQqupYd08O13v8cSNzrmj1JJdCt8Ujdb8v8krxfjp2BGDw05jMCxa8GTz556zvUi2Rnn9QUpv7MknUdSqQ3QZ1qG8k_stcVfvqw7xcfN5IympYYZjCoWLrz1s064_WZcATthsaB5v29Vw8v3ZJgV0o50xHCIv2NJhCXr0A6f8Q0kR7Tut0Lbvaq1B9_qHZIdI90vIFfqn6efjJCKYueM0QJlL2zZceAQsUeqMkfMKSwyy7iGLrpfzG4R3mmHCVZXr0B7GHavc",
  },
];

export const milestones = [
  {
    year: "2022",
    title: "TÁI CẤU TRÚC & CHUYỂN ĐỔI NỀN TẢNG",
    description:
      "Tập trung tối ưu hóa quy trình vận hành và xây dựng nền tảng công nghệ lõi mới.",
  },
  {
    year: "2023",
    title: "THÍCH ỨNG & CỦNG CỐ NỘI LỰC",
    description:
      "Vượt qua thử thách thị trường, khẳng định vị thế và mở rộng đội ngũ chuyên gia.",
  },
  {
    year: "2024",
    title: "KICK-OFF CHIẾN LƯỢC DÀI HẠN",
    description:
      "Khởi động các dự án trọng điểm hướng tới mục tiêu dẫn đầu hệ sinh thái số.",
  },
  {
    year: "2025 - Nay",
    title: "TĂNG TỐC & MỞ RỘNG QUY MÔ",
    description:
      "Phát triển đột phá các giải pháp AI và Cloud, vươn tầm quy mô quốc tế.",
  },
];

export const brands = [
  {
    id: "ahv-tech",
    slug: "ahv-tech",
    name: "AHV-TECH",
    url: "https://ahvtech.com/",
    icon: "code",
  },
  {
    id: "ahv-modnix",
    slug: "ahv-modnix",
    name: "AHV MODNIX",
    url: "https://ahvmodnix.com/",
    icon: "rocket_launch",
  },
  {
    id: "ahv-media",
    slug: "ahv-media",
    name: "AHV MEDIA BRAND",
    url: "https://youtube.com/@buno-animation?themeRefresh=1",
    icon: "movie_edit",
  },
  {
    id: "ahv-diy",
    slug: "ahv-diy",
    name: "AHV-DIY",
    url: "https://www.youtube.com/@CreationClever",
    icon: "psychology",
  },
  {
    id: "ahv-cloud",
    slug: "ahv-cloud",
    name: "AHV CLOUD",
    url: "https://ahvcloud.vn/",
    icon: "cloud_done",
  },
];
